import { ComponentClass, FC } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useQueryParams } from 'utils/useUriHelpers';
import { stringify } from 'querystring';

interface IndexPageProps {
  listPath: string;
  editPath: string;
  newPath: string;
  listComponent: ComponentClass<any> | FC<any>;
  editComponent: ComponentClass<any> | FC<any>;
}

export const IndexPage: FC<IndexPageProps> = ({
  listPath,
  editPath,
  newPath,
  listComponent,
  editComponent,
}) => {
  const { queryParams } = useQueryParams<{
    brand: string | null;
    name: string | null;
    availableAt: string | null;
  }>({
    brand: null,
    name: null,
    availableAt: null,
  });

  return (
    <Switch>
      <Route path={listPath} component={listComponent} />
      <Redirect
        exact
        from={newPath}
        to={{
          pathname: `${newPath}/generalities`,
          search: stringify(queryParams),
        }}
      />
      <Redirect
        exact
        from={editPath}
        to={{
          pathname: `${editPath}/generalities`,
          search: stringify(queryParams),
        }}
      />
      <Route path={[newPath, editPath]} component={editComponent} />
    </Switch>
  );
};
